import { render, staticRenderFns } from "./premium-feature-modal.vue?vue&type=template&id=4d30de62&scoped=true"
import script from "./premium-feature-modal.vue?vue&type=script&lang=js"
export * from "./premium-feature-modal.vue?vue&type=script&lang=js"
import style0 from "./premium-feature-modal.vue?vue&type=style&index=0&id=4d30de62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d30de62",
  null
  
)

export default component.exports